var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCataract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#133F7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 20.5C23 22.1569 21.6569 23.5 20 23.5C18.3431 23.5 17 22.1569 17 20.5C17 18.8431 18.3431 17.5 20 17.5C21.6569 17.5 23 18.8431 23 20.5ZM21.2858 20.5C21.2858 21.2101 20.7101 21.7858 20 21.7858C19.2899 21.7858 18.7142 21.2101 18.7142 20.5C18.7142 19.7899 19.2899 19.2143 20 19.2143C20.7101 19.2143 21.2858 19.7899 21.2858 20.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 20.5C7 20.5 12.796 13.0313 19.955 13.0002L20 13L20.0448 13.0002C27.2039 13.0312 33 20.5 33 20.5C33 20.5 27.1798 28 20 28C12.8203 28 7 20.5 7 20.5ZM20 26.421C23.2635 26.421 25.9091 23.7701 25.9091 20.5C25.9091 17.2421 23.2832 14.5988 20.0366 14.579L20 14.579L19.9632 14.579C16.7167 14.5989 14.0909 17.2422 14.0909 20.5C14.0909 23.7701 16.7365 26.421 20 26.421ZM27.4848 20.5C27.4848 19.13 27.1183 17.8458 26.4781 16.7406C27.0895 17.132 27.6696 17.5539 28.2115 17.9857C29.3139 18.8644 30.2097 19.7462 30.8288 20.408C30.858 20.4392 30.8865 20.4699 30.9144 20.5C30.8865 20.5301 30.858 20.5609 30.8288 20.592C30.2097 21.2538 29.3139 22.1356 28.2115 23.0143C27.6696 23.4462 27.0894 23.8681 26.478 24.2595C27.1183 23.1542 27.4848 21.87 27.4848 20.5ZM12.5152 20.5C12.5152 19.1301 12.8817 17.8459 13.5219 16.7407C12.9105 17.1321 12.3304 17.5539 11.7885 17.9857C10.6861 18.8644 9.79039 19.7462 9.17124 20.408C9.14209 20.4392 9.11354 20.4699 9.0856 20.5C9.11354 20.5301 9.14209 20.5609 9.17124 20.592C9.79039 21.2538 10.6861 22.1356 11.7885 23.0143C12.3304 23.4462 12.9106 23.868 13.522 24.2595C12.8817 23.1542 12.5152 21.87 12.5152 20.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 20.5C28.7018 20.5 31.5 17.7018 31.5 14.25C31.5 10.7982 28.7018 8 25.25 8C21.7982 8 19 10.7982 19 14.25C19 17.7018 21.7982 20.5 25.25 20.5Z",
    fill: "#133F7A",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCataract);
export default __webpack_public_path__ + "static/media/cataract.91bed79e8169ab3311b129a34eb823aa.svg";
export { ForwardRef as ReactComponent };